<template>
  <div class="page-control">
    <button class="page-change" v-show="CurrentPage != 1" @click="SelectPage(CurrentPage - 1)">&lt; 上一頁</button>
    
    <label v-for="n in PageArray" :key="n" :class="PageNumberStyle(n)" @click="SelectPage(n)">{{ n }}</label>
    <button class="page-change" v-show="CurrentPage != MaxPage" @click="SelectPage(CurrentPage + 1)">下一頁 &gt;</button>
    
  </div>
</template>

<script>
import '@/components/pageControl/pageControl.scss';

export default {
  name: 'PageControl',
  props: {
    CurrentPage: Number,
    MaxPage: Number,
  },
  data() {
    return {
      PageNumber: 0,
      PageArray: [],
    };
  },
  mounted() {
    this.CreatPageArray(this.CurrentPage);
  },
  watch: {
    CurrentPage(No) {
      this.CreatPageArray(No);
    },
    MaxPage(){
      this.CreatPageArray(this.CurrentPage);
    }
  },
  methods: {
    PageNumberStyle(No) {
      return No == this.CurrentPage ? 'page-item-selected' : 'page-item';
    },
    CreatPageArray(CurrentPage) {
      this.PageArray = [];
      if (this.MaxPage <= 5) {
        for (let i = 1; i <= this.MaxPage; i++) {
          this.PageArray.push(i);
        }
      } else if (CurrentPage >= 3) {
        if (CurrentPage > this.MaxPage - 2) {
          for (let i = CurrentPage - 2; i <= this.MaxPage; i++) {
            this.PageArray.push(i);
          }
        } else {
          for (let i = CurrentPage - 2; i <= CurrentPage + 2; i++) {
            this.PageArray.push(i);
          }
        }
      } else {
        for (let i = 1; i <= 5; i++) {
          this.PageArray.push(i);
        }
      }
    },
    SelectPage(No) {
      this.$emit('select-page', No);
    },
  },
  components: {},
};
</script>
